import EventSourcePolyfill from './EventSourcePolyfill';

export default EventSourcePolyfill;
export { EventSourcePolyfill };
